import { Tooltip, type TooltipProps, styled, tooltipClasses } from "@mui/material"

// Module-level constant: MUI Popper recreates its popper.js instance
// whenever the modifiers reference changes
const TOOLTIP_SLOT_PROPS: TooltipProps["slotProps"] = {
  popper: {
    modifiers: [
      {
        // Match the popper width to the anchor (the card) width
        name: "sameWidth",
        enabled: true,
        phase: "beforeWrite",
        fn: ({ state }) => {
          state.styles.popper.width = `${state.rects.reference.width}px`
        },
        effect: ({ state }) => {
          state.elements.popper.style.width = `${
            (state.elements.reference as HTMLElement).offsetWidth
          }px`
        },
      },
      {
        name: "offset",
        options: {
          offset: [0, -3],
        },
      },
    ],
  },
}

export const HealthMissionCardTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip
      describeChild
      {...props}
      classes={{ popper: className }}
      arrow={false}
      slotProps={TOOLTIP_SLOT_PROPS}
    />
  ),
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
    padding: 0,
    borderRadius: theme.spacing(1.25),
  },
}))
